<template>
  <v-dialog v-model="dialog" max-width="620" persistent>
    <template v-slot:activator="{ on }">
      <v-btn :disabled="disabled" :dark="disabled" color="white" text v-on="on">
        <div class="icon-button-container">
          <div class="icon-button-text">
            Inställningar
          </div>
          <div class="icon-button-icon">
            <v-icon right style="color: rgba(255,255,255,1);">
              mdi-cog
            </v-icon>
          </div>
        </div>
      </v-btn>
    </template>
    <v-dialog v-model="deleteDialog" max-width="480">
      <v-card>
        <v-card-title
          >Är du säker på att du vill radera
          {{ org ? org.name : "" }}?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Nej</v-btn>
          <v-btn text color="primary" type="submit" @click="remove">Ja</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card v-if="org">
      <v-card-title class="color-a">
        Redigerar organisation "{{ org.name }}"
      </v-card-title>
      <v-card-subtitle class="color-a" style="padding-top: 10px">
        Organisationstyp:
        {{ org.organizationType != null ? org.organizationType : "förening" }}
      </v-card-subtitle>
      <v-card-text>
        <v-form v-model="valid" ref="form">
          <v-tabs
            v-model="tab"
            background-color="white"
            color="primary"
            style="margin-bottom:20px;"
          >
            <v-tab href="#tab-1">Inställningar</v-tab>
            <v-tab href="#tab-2">Administratörer</v-tab>
            <v-tab href="#tab-3">Faktureringsuppgifter</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item :key="'1'" :value="'tab-1'">
              <v-text-field
                v-model="form.name"
                label="Namn"
                :rules="nameRules"
                required
              ></v-text-field>
              <v-text-field
                v-model="form.email"
                label="E-postadress"
                :rules="emailRules"
                required
              ></v-text-field>
              <p
                style=" margin-top: 10px; border: 1px solid #ccc; padding: 11px; border-radius: 4px; "
              >
                Innan ni lägger in medlemmar i Percap måste ni enligt GDPR
                godkänna vårt personbiträdesavtal och ange vem hos er som är
                ansvarig.
                <a
                  href="https://firebasestorage.googleapis.com/v0/b/percap-7af8f.appspot.com/o/assets%2Fpersonal-data-assistant-agreement.html?alt=media&token=4dc020aa-4d47-46fc-abf3-9f698c025f4f"
                  target="_blank"
                  >Tryck här för att läsa avtalet</a
                >. Ni godkänner avtalet genom att ange personuppgiftsansvarig
                nedan.
              </p>

              <v-text-field
                v-model="form.nameGdpr"
                label="Namn på personuppgiftsansvarig"
                prepend-icon="mdi-form-textbox"
                :rules="nameRules"
                required
              ></v-text-field>

              <v-text-field
                v-model="form.emailGdpr"
                label="E-postaddress till personuppgiftsansvarig"
                prepend-icon="mdi-form-textbox"
                :rules="emailRules"
                required
              ></v-text-field>
            </v-tab-item>
            <v-tab-item :key="'2'" :value="'tab-2'">
              <h3>Administratörer</h3>
              <v-list>
                <v-list-item-group color="primary">
                  <v-list-item v-for="(admin, i) in org.admin" :key="i">
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-icon color="grey lighten-1">mdi-account</v-icon>
                        {{ admin }}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon @click="removeAdmin(admin)">
                        <v-icon color="warning">mdi-close</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <v-row style="align-items:baseline">
                <v-col cols="12">
                  <h3>Lägg till administratör</h3>
                </v-col>
                <v-col cols="9" style="padding-top:0px;">
                  <v-text-field
                    v-model="newAdmin"
                    label="Personnummer"
                    :rules="ssnRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" style="padding-top:0px;">
                  <v-btn small @click="addAdmin">Lägg till</v-btn>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item :key="'3'" :value="'tab-3'">
              <template v-if="form.invoicingStatus !== 1">
                <p
                  style=" margin-top: 10px; border: 1px solid #ccc; padding: 11px; border-radius: 4px; "
                >
                  Om ni vill betala med faktura, kryssa i "ansök om
                  fakturabetalning". När fakturauppgifterna granskats och
                  godkänts kommer möten som skapas för organisationen kunna
                  betalas med faktura.
                </p>
                <v-checkbox
                  v-model="invoiceRequest"
                  v-if="form.invoicingStatus !== 0"
                  label="Ansök om fakturabetalning"
                />
                <v-text-field
                  v-model="form.invoiceEmail"
                  label="E-postadress för faktura"
                  :disabled="!invoiceRequest && form.invoicingStatus !== 0"
                ></v-text-field>
                <v-text-field
                  v-model="form.invoiceReference"
                  label="Önskad fakturareferens"
                  :disabled="!invoiceRequest && form.invoicingStatus !== 0"
                ></v-text-field>
                <v-text-field
                  v-model="form.ssn"
                  label="Organisationsnummer"
                  :disabled="!invoiceRequest && form.invoicingStatus !== 0"
                ></v-text-field>
                <h3>Adress</h3>
                <v-text-field
                  v-model="form.address"
                  label="Adress"
                  :disabled="!invoiceRequest && form.invoicingStatus !== 0"
                ></v-text-field>
                <v-row>
                  <v-col cols="4" style="padding-top:0px">
                    <v-text-field
                      v-model="form.zipcode"
                      label="Postnummer"
                      :disabled="!invoiceRequest && form.invoicingStatus !== 0"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="8" style="padding-top:0px">
                    <v-text-field
                      v-model="form.city"
                      label="Ort"
                      :disabled="!invoiceRequest && form.invoicingStatus !== 0"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </template>
              <template v-if="form.invoicingStatus === 1">
                <p
                  style=" margin-top: 10px; border: 1px solid #ccc; padding: 11px; border-radius: 4px; "
                >
                  Fakturaavtal godkänt och aktivt. <br />
                  Faktura skickas till email: {{ form.invoiceEmail }} <br />
                  Fakturareferens: {{ form.invoiceReference }} <br />
                  AvtalsID:
                  {{ form.invoiceContractId }}
                </p>
              </template>
              <template v-if="form.invoicingStatus === 0">
                <p
                  style=" margin-top: 10px; border: 1px solid #ccc; padding: 11px; border-radius: 4px; "
                >
                  Fakturabetalning begärd. Fakturauppgifter inväntar
                  godkännande.
                </p>
              </template>
            </v-tab-item>
          </v-tabs-items>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="deleteDialog = true"
          ><v-icon left>mdi-delete</v-icon> Radera organisation</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn text @click="close">Avbryt</v-btn>
        <v-btn text color="primary" type="submit" @click="save">Spara</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { isSSN } from "@/assets/lib/isSSN.js";

export default {
  props: {
    org: Object,
    disabled: Boolean
  },
  data() {
    return {
      valid: true,
      dialog: false,
      deleteDialog: false,
      form: { ...this.org },
      originalInvoice: "",
      tab: "",
      newAdmin: "",
      ssnRules: [
        v =>
          "" === v ||
          isSSN(v) ||
          `Måste vara ett personnummer i formatet ÅÅÅÅMMDDNNNN`
      ],
      emailRules: [v => !!v || "Email är obligatoriskt"],
      nameRules: [v => !!v || "Namn är obligatoriskt"],
      invoiceRequest: false
    };
  },
  watch: {
    org: function(value) {
      this.form = { ...value };
    }
  },
  computed: {
    isSSN() {
      return isSSN(this.newAdmin);
    }
  },
  methods: {
    close() {
      this.dialog = false;
    },
    async save() {
      if (
        this.form.invoiceEmail !== undefined &&
        this.form.invoiceEmail !== null &&
        this.form.invoicingStatus !== 1
      ) {
        this.form.invoicingStatus = 0;
      }
      if (this.$refs.form.validate()) {
        console.log("Saving organization...");
        const success = await this.$store.dispatch(
          "organizations/editOrganization",
          {
            organizationId: this.org.id,
            ...this.form
          }
        );
        if (success) {
          this.close();
        }
      }
    },
    async remove() {
      const success = await this.$store.dispatch(
        "organizations/deleteOrganization",
        {
          organizationId: this.org.id
        }
      );
      if (success) {
        await this.$router.replace({ path: "/organization" });
        this.close();
      }
    },
    addAdmin() {
      if (!this.newAdmin || !this.isSSN) return;
      this.form.admin.push(this.newAdmin);
      this.newAdmin = "";
    },
    removeAdmin(pnr) {
      console.log(pnr);
      this.form.admin = this.form.admin.filter(item => item != pnr);
    }
  },
  mounted() {
    this.form = { ...this.org };
  }
};
</script>

<style></style>
